// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px !important;

}


::-webkit-scrollbar-track {
  background: #BABABA;
}



/* Custom styles for WebKit scrollbar */
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* Change the background color of the track */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  /* Change the color of the scrollbar handle */
  border-radius: 5px;
  /* Add rounded corners to the scrollbar handle */
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
  /* Change the color of the scrollbar handle on hover */
}

/* Button (arrow buttons at the ends of the scrollbar) */
::-webkit-scrollbar-button {
  display: none;
  /* Hide the scrollbar buttons */
}

/* Corner (corner where vertical and horizontal scrollbars meet) */
::-webkit-scrollbar-corner {
  background: #f1f1f1;
  /* Change the background color of the scrollbar corner */
}

.sidebar-img {


  
  height: 12vh;
  cursor: pointer;
  /* width: 300px; */


}


.select_containers {
  color: white;
  text-align: center;
  font-size: 40px;
  font-weight: 700;
  text-shadow: 0px 3px 4px #00000073;
}


@media only screen and (max-width: 900px) {
  .show1{
    display: none !important;
  }
  /* .g-sidenav-show:not(.rtl) .sidenav {
    display: none !important;
  } */
}

@media only screen and (max-width: 1200px) {
  .sidenav navbar navbar-vertical navbar-expand-xs {

    display: none !important;
  }
}


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;;AAEpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,UAAU;EACV,sBAAsB;;AAExB;;;AAGA;EACE,mBAAmB;AACrB;;;;AAIA,uCAAuC;AACvC,UAAU;AACV;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA,kEAAkE;AAClE;EACE,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;;;;EAIE,YAAY;EACZ,eAAe;EACf,kBAAkB;;;AAGpB;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;;AAGA;EACE;IACE,wBAAwB;EAC1B;EACA;;KAEG;AACL;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n::-webkit-scrollbar {\n  width: 4px;\n  height: 4px !important;\n\n}\n\n\n::-webkit-scrollbar-track {\n  background: #BABABA;\n}\n\n\n\n/* Custom styles for WebKit scrollbar */\n/* Track */\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  /* Change the background color of the track */\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #888;\n  /* Change the color of the scrollbar handle */\n  border-radius: 5px;\n  /* Add rounded corners to the scrollbar handle */\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n  /* Change the color of the scrollbar handle on hover */\n}\n\n/* Button (arrow buttons at the ends of the scrollbar) */\n::-webkit-scrollbar-button {\n  display: none;\n  /* Hide the scrollbar buttons */\n}\n\n/* Corner (corner where vertical and horizontal scrollbars meet) */\n::-webkit-scrollbar-corner {\n  background: #f1f1f1;\n  /* Change the background color of the scrollbar corner */\n}\n\n.sidebar-img {\n\n\n  \n  height: 12vh;\n  cursor: pointer;\n  /* width: 300px; */\n\n\n}\n\n\n.select_containers {\n  color: white;\n  text-align: center;\n  font-size: 40px;\n  font-weight: 700;\n  text-shadow: 0px 3px 4px #00000073;\n}\n\n\n@media only screen and (max-width: 900px) {\n  .show1{\n    display: none !important;\n  }\n  /* .g-sidenav-show:not(.rtl) .sidenav {\n    display: none !important;\n  } */\n}\n\n@media only screen and (max-width: 1200px) {\n  .sidenav navbar navbar-vertical navbar-expand-xs {\n\n    display: none !important;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
